import { render, staticRenderFns } from "./driverOrderConnectRecordLists.vue?vue&type=template&id=50491f62&scoped=true&"
import script from "./driverOrderConnectRecordLists.vue?vue&type=script&lang=js&"
export * from "./driverOrderConnectRecordLists.vue?vue&type=script&lang=js&"
import style0 from "./driverOrderConnectRecordLists.vue?vue&type=style&index=0&id=50491f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50491f62",
  null
  
)

export default component.exports